import AddIcon from '@mui/icons-material/Add';
import {
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectContactList, selectUserList } from '../redux/reducers/organizationReducer';

export default function PersonSelector({ id, title, handlePersonChange, handleAddNew, fill, contacts = [] }) {
  const { t } = useTranslation();
  const [showSelect, setShowSelect] = useState(false);
  const userList = useSelector(selectUserList);
  const contactList = useSelector(selectContactList);
  const [selectedList, setSelectedList] = useState(contacts);

  const handleAdd = () => {
    handleAddNew();
  };

  const handleChange = (event) => {
    const { value } = event.target;
    // Ensure array form and no undefined entries in list
    const newValue = typeof value === 'string' ? value.split(',') : value.filter((x) => x).flat();
    setSelectedList([...new Set([...newValue])]);
  };

  const handleClose = () => {
    handlePersonChange(selectedList, id || null);
    setShowSelect(false);
  };

  function findNames(idList) {
    const listOfNames = idList.map(
      (personId) =>
        userList.find((user) => user.id === personId)?.firstName ??
        contactList.find((contact) => contact.id === personId)?.name ?? [''],
    );
    return listOfNames.join(', ');
  }

  useEffect(() => {
    setSelectedList(contacts);
  }, [contacts]);

  return (
    <FormControl fullWidth={fill} sx={!fill ? { width: '250px' } : {}}>
      <InputLabel shrink sx={{ px: 1, backgroundColor: 'white' }} htmlFor="label">
        {title}
      </InputLabel>
      <Select
        id={`${id}-contact-person`}
        size="small"
        displayEmpty
        value={selectedList}
        multiple
        variant="outlined"
        MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
        open={showSelect}
        onOpen={() => setShowSelect(true)}
        onClose={() => handleClose()}
        renderValue={(selected) => <Typography>{findNames(selected)}</Typography>}
        onChange={handleChange}
      >
        {userList.length > 0 && <ListSubheader>{t('person.selector.users')}</ListSubheader>}
        {userList.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            <Checkbox variant="checkbox" checked={selectedList.includes(user.id)} />
            <ListItemText>
              <Typography variant="bold">{user.firstName}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
        <ListSubheader>{t('person.selector.contacts')}</ListSubheader>
        {contactList.map((contact) => (
          <MenuItem key={contact.id} value={contact.id}>
            <Checkbox id={`${contact.name}-checkbox`} variant="checkbox" checked={selectedList.includes(contact.id)} />
            <ListItemText>
              <Typography variant="bold">{contact.name}</Typography>
            </ListItemText>
          </MenuItem>
        ))}
        <MenuItem key="addNew">
          <Button id='add-contact-person' startIcon={<AddIcon />} onClick={() => handleAdd()}>
            {t('person.contact.add')}
          </Button>
        </MenuItem>
      </Select>
    </FormControl>
  );
}
